export const QURAN_ROUTE_PAGE_START = 0
export const QURAN_ROUTE_PAGE_END = 604
export const QURAN_ROUTE_PAGE_COUNT = QURAN_ROUTE_PAGE_END - QURAN_ROUTE_PAGE_START + 1

/** Converts the zero-based reader route page to the bundled data page number. */
export const getQuranDataPageFromRoutePage = (routePage: number): number => routePage + 1

/** Returns whether a value is a valid zero-based Quran reader route page. */
export const isQuranRoutePage = (routePage: number): boolean =>
  Number.isInteger(routePage) &&
  routePage >= QURAN_ROUTE_PAGE_START &&
  routePage <= QURAN_ROUTE_PAGE_END

type QuranRoutePageValue = string | string[] | number | undefined

/** Parses a Next.js route value without accepting invalid or ambiguous pages. */
export const parseQuranRoutePage = (value: QuranRoutePageValue): number | null => {
  const rawValue = Array.isArray(value) ? value[0] : value
  if (rawValue === undefined || String(rawValue).trim() === '') return null

  const routePage = Number(rawValue)
  return isQuranRoutePage(routePage) ? routePage : null
}

/** Prefers the live router value while it is available during hydration. */
export const resolveQuranRoutePage = (
  routerPage: QuranRoutePageValue,
  serverPage: QuranRoutePageValue,
): number | null => parseQuranRoutePage(routerPage) ?? parseQuranRoutePage(serverPage)
